import { api } from '../lib/api'

export async function createStripeConnectedAccount() {
  // Legacy (non-/api) endpoint. Prefer createStripeConnectOnboarding().
  const { data } = await api.post<{ account_id: string }>('/stripe/connect/create-account/')
  return data
}

export async function createStripeOnboardingLink() {
  // Legacy (non-/api) endpoint. Prefer createStripeConnectOnboarding().
  const { data } = await api.post<{ url: string }>('/stripe/connect/onboarding-link/')
  return data
}

export async function createStripeConnectOnboarding() {
  const { data } = await api.post<{ url: string }>('/api/stripe/connect/onboarding/')
  return data
}
